import { takeLatest, call, put, select } from "redux-saga/effects";
import { FETCH_DOC_REQUEST, SEARCH_DOCS } from "../actions/types";
import {
  fetchDocSuccess,
  fetchDocFailure,
  searchDocsResults,
} from "../actions/docsActions";
import { fetchDoc } from "../apis/docsApi";
import { getDocFromCache } from "../getters/docsGetters";

function* handleFetchDoc(action) {
  const docPath = action.payload;

  // Return cached copy if available
  const cached = yield select(getDocFromCache, docPath);
  if (cached) {
    yield put(fetchDocSuccess(docPath, cached));
    return;
  }

  try {
    const content = yield call(fetchDoc, docPath);
    yield put(fetchDocSuccess(docPath, content));
  } catch (err) {
    yield put(fetchDocFailure(docPath, err.message));
  }
}

function* handleSearchDocs(action) {
  const query = action.payload?.toLowerCase().trim();
  if (!query || query.length < 2) {
    yield put(searchDocsResults([]));
    return;
  }

  // Client-side search: scan the manifest labels and paths
  try {
    const manifest = yield call(() =>
      import("../docsManifest.json").then((m) => m.default)
    );
    const results = [];

    function walk(nodes) {
      for (const node of nodes) {
        if (node.type === "file") {
          if (
            node.label.toLowerCase().includes(query) ||
            node.path.toLowerCase().includes(query)
          ) {
            results.push({ label: node.label, path: node.path });
          }
        }
        if (node.children) walk(node.children);
      }
    }
    walk(manifest);

    yield put(searchDocsResults(results.slice(0, 30)));
  } catch (err) {
    yield put(searchDocsResults([]));
  }
}

export default function* docsSaga() {
  yield takeLatest(FETCH_DOC_REQUEST, handleFetchDoc);
  yield takeLatest(SEARCH_DOCS, handleSearchDocs);
}
